import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ITimeSelectorProps {
    id: string;
    cssClass?: string;
    date: Date;
    dataCy?: string;
    onSelectOp?: number;
    parseFormats?: string[];
    dateFormat?: string,
    disabled?: boolean;
    onChangeCallback?: (date: Date) => void; // use callback to bubble back onchange value for the date selector control. This is used in case you want to bypass store for temporary data management within the state of the parent.
    callbackContext?: React.Component<any, any>; // if above callback is used, it is best to pass the parent contexts (this). This way you callback "this" context will be properly set.
    interval?: number;
    width?: number;
    height?: number;
    max?: Date;
    smallHeight?: boolean
    focusOnMount?: boolean
    onEnterCallBack?: (date: Date) => void;
    onEscapeCallBack?: () => void;
    isRequired?: boolean;
    placeholder?: string;
}

class TimeSelector extends React.Component<ITimeSelectorProps, never> {
    private culture: string;

    constructor(props: ITimeSelectorProps) {
        super(props);
        this.culture = sessionStore.getUserLanguageCodeFull();
    }

    public componentDidMount(): void {
        var self = this;
        $("#" + this.props.id).kendoTimePicker({
            culture: self.culture,
            format: this.dateFormat,
            parseFormats: this.parseFormats,
            value: self.props.date,
            interval: self.props.interval,
            max: self.props.max,

            change: e => {
                var dt = e.sender.value();

                if (self.props.isRequired && !dt) {
                    e.sender.value(self.props.date);
                    return self.props.date;
                }

                if (self.props.onSelectOp != null) {
                    var operation = new LocalEvent(self.props.onSelectOp);
                    operation.AddItem("value", dt);
                    LocalEventDispatcher.dispatch(operation);
                }

                if (self.props.onChangeCallback != null) {
                    self.props.onChangeCallback.apply(self.props.callbackContext, [dt]);
                }
            }
        });

        if (!isNaN(this.props.width) && this.props.width != null) {
            $("#" + this.props.id).parent().css("width", (this.props.width - 30).toString() + "px").parent().css("width", this.props.width.toString() + "px");
        }

        if (!isNaN(this.props.height) && this.props.height != null) {
            $("#" + this.props.id).parent().css("height", this.props.height.toString() + "px");
        }

        $("#" + this.props.id).data("kendoTimePicker").enable(!this.props.disabled);

        if (this.props.smallHeight == true) {
            $("#" + this.props.id).parent().css("height", "23px").css("padding-left", "2px");
            $("#" + this.props.id).parent().find("span.k-icon").css("margin-top", "-6px");
        }

        if (this.props.focusOnMount == true) {
            let inputRef = $("#" + this.props.id);
            inputRef.focus();
            inputRef.select();
        }
    }

    public shouldComponentUpdate(nextProps: ITimeSelectorProps): boolean {
        return (
            nextProps.disabled !== this.props.disabled
            || nextProps.date !== this.props.date
        );
    }

    public componentDidUpdate(): void {
        $("#" + this.props.id).data("kendoTimePicker")?.value(kendo.toString(this.props.date, this.dateFormat, this.culture));
        $("#" + this.props.id).data("kendoTimePicker")?.enable(!this.props.disabled);
    }

    public componentWillUnmount(): void {
        try {
            $("#" + this.props.id).data("kendoTimePicker").destroy();
        }
        catch (e) { }
    }

    public render(): JSX.Element {
        var css = "";
        if (this.props.cssClass != null) {
            css = this.props.cssClass;
        }

        let divStyle: React.CSSProperties = {};
        let inputStyle: React.CSSProperties = {};
        if (this.props.smallHeight == true) {
            inputStyle.padding = "0px";
            inputStyle.margin = "0px";
            divStyle.marginBottom = "2px";
            divStyle.marginTop = "-2px";
        }

        return (
            <div style={divStyle}>
                <input
                    type="text"
                    disabled={!!this.props.disabled}
                    id={this.props.id}
                    className={css}
                    data-cy={this.props.dataCy}
                    style={inputStyle}
                    onKeyDown={this.inputKeyDown.bind(this)}
                    placeholder={this.props.placeholder}
                />
            </div>
        );
    }

    private inputKeyDown(e: React.KeyboardEvent): void {
        // enter
        if (e.keyCode === 13 && this.props.onEnterCallBack != null) {
            this.props.onEnterCallBack($("#" + this.props.id).data("kendoTimePicker").value());
        }

        // escape
        if (e.keyCode === 27 && this.props.onEscapeCallBack != null) {
            this.props.onEscapeCallBack();
        }
    }

    private get dateFormat(): string { return this.props.dateFormat || "HH:mm"; }

    private get parseFormats(): string[] { return ["H mmtt", "H mm tt", "Htt", "H tt", "H'h'mm", "H'h 'mm", "H'h'", "H"]; }
}

export { TimeSelector };
